module.exports = __webpack_public_path__ + "static/media/ic_close_w.ca9d916c.svg";